import Decimal from 'decimal.js'
import { round } from './common'

function calculateSingleTax(
    subtotal: Decimal,
    rate: Decimal,
    isTaxInclusive: boolean,
): Decimal {
    const sumTax: Decimal = isTaxInclusive
        ? subtotal.sub(subtotal.div(rate.div(100).plus(1)))
        : subtotal.mul(rate).div(100)
    return round(sumTax)
}

function calculateTax(
    subtotal: Decimal,
    taxRate?: number,
    isTaxInclusive: boolean = false,
): Decimal {
    if (!taxRate || taxRate === 0 || subtotal.lessThanOrEqualTo(0)) {
        return new Decimal(0)
    }
    return calculateSingleTax(subtotal, new Decimal(taxRate), isTaxInclusive)
}

export default calculateTax
